import { MyScorecardCard } from './action';
import { ActionsType } from './actions.model';

export const actions: ActionsType = {
    MyScorecardCard,
};
